import React from "react"
import NavLinks from "./navlinks.js"
import "../styles/footer.module.css"

export default () => {
    return(
        <footer>
            <NavLinks />
        </footer>
    )
}
